import React, {createContext, useContext} from "react";
import {Helmet} from "react-helmet";

interface IFlandersContext {
  sources: FlandersScriptSources;
  setSources: React.Dispatch<React.SetStateAction<FlandersScriptSources>>;
}

type FlandersScriptSources = {
  clientScriptSource: string;
  polyfillScriptSource: string;
}

const FlandersContext = createContext<IFlandersContext | null>(null);

export const FlandersScriptProvider = (
  {children, clientScriptSource, polyfillScriptSource, headerScript, footerScript}
) => {
  const [sources, setSources] = React.useState<FlandersScriptSources>({
    clientScriptSource: clientScriptSource,
    polyfillScriptSource: polyfillScriptSource,
  });

  return (
    <FlandersContext.Provider value={{sources, setSources}}>
      <Helmet>
        <script src={clientScriptSource}/>
        <script src={polyfillScriptSource}/>
      </Helmet>
      {children}
    </FlandersContext.Provider>
  );
}

export const useFlandersScript = () => useContext(FlandersContext);